export default {
    "fr": {
        "Reference": "Référence",
        "Status": "Etat",
        "achieve": "terminée",
        "current": "en cours",
        "pending": "en attente",
        "report": "rapport",
        "Price": "Prix",
        "Started": "Début",
        "Ended": "Fin"
    }
}
